import { useCallback } from 'react';
import { useToggleState } from '@lingoda/hooks';
import { Drawer } from '@lingoda/ui';
import { colorsPalette, styled } from '@lingoda/ui/theme';
import { HeaderAvatar } from './HeaderAvatar';
import type * as React from 'react';

const StyledDrawer = styled(Drawer)(({ theme }) => ({
    '& .MuiDrawer-paper': {
        width: 'min-content',
        backgroundColor: colorsPalette.whiteSolid[100],
        boxShadow: theme.shadows[4],
        paddingBottom: theme.spacing(2),
    },
}));

interface Props {
    children: (handleClose: () => void) => React.ReactElement<unknown>;
}

export const HeaderDrawer = (props: Props) => {
    const [opened, open, close] = useToggleState(false);
    const handleToggle = useCallback(() => {
        opened ? close() : open();
    }, [opened, close, open]);

    return (
        <>
            <HeaderAvatar onClick={handleToggle} />
            <StyledDrawer open={opened} onClose={close} anchor="right">
                {props.children(close)}
            </StyledDrawer>
        </>
    );
};
